import type { ReactNode } from "react";
import "./CornerIconsLegend.scss";
import IconHouseFill from "@/shared/components/generic/icons/IconHouseFill.tsx";
import { colors } from "@/shared/style/design_system/Colors.ts";
import { useTranslation } from "react-i18next";
import IconLocationPinFill from "@/shared/components/generic/icons/IconLocationPinFill.tsx";
import IconLogoMycawan from "@/shared/components/generic/icons/IconLogoMycawan.tsx";
import type { EntityScope } from "@/pages/human-resources/time-management/components/schedule-palette/bottom-row/legend/EntityScope.ts";

interface Properties {
  scopes: Set<EntityScope>;
}

export default function CornerIconsLegend(props: Properties): ReactNode {
  const { t } = useTranslation();
  const iconSize = 10;
  return (
    props.scopes.size > 0 && (
      <div className="corner-icons-legend">
        {props.scopes.has("domain") && (
          <div className="domain">
            <IconHouseFill
              color={colors.foam500}
              width={iconSize}
              height={iconSize}
            />
            <div>{t("domain")}</div>
          </div>
        )}
        {props.scopes.has("site") && (
          <div className="site">
            <IconLocationPinFill
              color={colors.foam500}
              width={iconSize}
              height={iconSize}
            />
            <div>{t("site")}</div>
          </div>
        )}
        {props.scopes.has("system") && (
          <div className="system">
            <IconLogoMycawan
              color={colors.foam500}
              width={iconSize * 1.5}
              height={iconSize * 1.5}
            />
            <div>{t("mycawan")}</div>
          </div>
        )}
      </div>
    )
  );
}
